/**
 * @module モバイル向けフッター部共通コンポーネント
 */
export default {
  name: 'MobileFooter',
  data() {
    return {
      toggle: false,
      timerObj: null,
      marginTop70: {
        'margin-top': '95px',
      },
      // variant: "default",
      width: document.body.clientWidth,
    };
  },
  mounted() {
    document.addEventListener('touchmove', this.touchmove);
    document.addEventListener('click', this.onClick);
  },
  beforeDestroy() {
    document.removeEventListener('touchmove', this.touchmove);
    document.removeEventListener('click', this.onClick);
  },
  /** @type {Methods} */
  methods: {
    /**
     *ホームキュリティボタン押下時の処理
     */
    returnDisplayDistrict() {
      if (this.$store.state.districtOneCountFlag) {
        // 対象地区が1地区の場合、対象地区詳細画面に遷移する。
        this.$store.commit('setCustomerNumber', {
          customerNumber: this.$store.state.oneDistrictCustomerNumber,
        });
        this.$store.commit('setDistrictSplitNumber', {
          districtSplitNumber: this.$store.state.oneDistrictSplitNumber,
        });
        this.$router.push('/displayDistrictDetail');
      } else {
        // 対象地区が2地区以上存在するの場合、ホームセキュリティ画面に遷移する。
        this.$router.push('/homeSecurity');
      }
    },
    /**
     * カメラボタン押下時の処理
     */
    returnCamera() {
      if (this.$store.state.cameraOneCountFlag) {
        // カメラが1台の場合、カメラ詳細画面に遷移する。
        this.$store.commit('setCustomerNumber', {
          customerNumber: this.$store.state.oneCameraCustomerNumber,
        });
        this.$store.commit('setDeviceID', {
          deviceID: this.$store.state.oneCameraDeviceID,
        });
        this.$router.push('/cameraDetail');
      } else {
        // カメラが2台以上の場合、カメラ画面に遷移する。
        this.$router.push('/camera');
      }
    },
    /**
     * 画面表示中の判定
     * @param {String} tag 判定対象画面パス
     * @returns boolean 判定結果
     */
    opacity(tag) {
      return tag === this.$route.path;
    },
    /**
     * タイマー設定
     */
    start: function () {
      let self = this;
      this.timerObj = setInterval(function () {
        clearInterval(self.timerObj);
        self.toggle = false;
      }, 10000);
    },
    /**
     * タッチして動かした時のイベント処理
     */
    touchmove: function () {
      this.toggle = true;
      clearInterval(this.timerObj);
      this.start();
    },
    /**
     * クリック時のイベント処理
     */
    onClick: function () {
      this.toggle = false;
      clearInterval(this.timerObj);
    },
    /**
     * historyに追加しないで画面遷移
     * @param {String} url
     */
    router: function (url) {
      this.$router.replace({
        path: url,
      });
    },
  },
  watch: {
    toggle(newVal) {
      this.$store.commit('setToggle', newVal);
    },
  },
};
